import React from "react";
import { MainContainer } from "../Components/Elements";
import PagesNav from "../Components/PagesNav";
import SearchInput from "../Components/SearchInput";
import AddInput from "../Components/AddInput";
import { Offcanvas, Pagination, Table } from "react-bootstrap";
import TableBtns from "../Components/TableBtns";
import MainInput from "../Components/MainInput";
import Shimmer from "../Components/Shimmer";
import NoData from "../Components/NoData";
import PaymentMethodHook from "../hooks/PaymentMethodHook";
import UploadImage from "../Components/UploadImage";

const PaymentMethod = () => {
  const {
    NavItems,
    setSearch,
    handleShow,
    show,
    handleClose,
    addNewPaymentMethod,
    setPaymentMethodEn,
    paymentMethodEn,
    paymentMethodAr,
    setPaymentMethodAr,
    allPaymentMethod,
    handlePageChange,
    getPageNumbers,
    loadingAddPaymentMethod,
    currentPage,
    totalPages,
    deletePaymentMethod,
    deletePaymentMethodLoading,
    clickOnePaymentMethod,
    showEditPaymentMethod,
    handleCloseEditPaymentMethod,
    editPaymentMethod,
    setNameEnEdit,
    nameEnEdit,
    nameArEdit,
    setNameArEdit,
    loadingEditPaymentMethod,
    loading,
    handleImageChange,
    imageForEdit
  } = PaymentMethodHook();
  return (
    <>
      <MainContainer>
        <div className="d-flex gap-3 mb-3 align-items-center justify-content-end">
            <SearchInput search={(e) => setSearch(e.target.value)} />
            <AddInput onClick={handleShow} />
        </div>
        <Table hover className="text-center">
          <thead>
            <tr>
              <th className="bg-light">Payment Method (English)</th>
              <th className="bg-light">Payment Method (Arabic)</th>
              <th className="bg-light">Image</th>

              <th className="bg-light">Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              Array.from({ length: 5 }, (_, index) => (
                <Shimmer key={index} type={"table"} colSpan={4} />
              ))
            ) : allPaymentMethod.length === 0 ? (
              <td colSpan={3}>
                <NoData />
              </td>
            ) : (
              allPaymentMethod.map((team, index) => (
                <tr key={index}>
                  <td>{team.nameEn}</td>
                  <td>{team.nameAr}</td>
                  <td>
                    <img
                      alt="payment-method-image"
                      style={{
                        width: "75px",
                        height: "75px",
                        objectFit: "contain",
                      }}
                      src={team?.image}
                    />
                  </td>
                  <td>
                    <TableBtns
                      onClickDelete={() => {
                        deletePaymentMethod(team?._id);
                      }}
                      deleteloading={deletePaymentMethodLoading[team?._id]}
                      onClickEdit={() => {
                        clickOnePaymentMethod(team);
                      }}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>

        {allPaymentMethod.length > 0 && (
          <div className="d-flex justify-content-center mt-3">
            <Pagination>
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {getPageNumbers().map((pageNumber) => (
                <Pagination.Item
                  linkClassName="bg-white text-black"
                  key={pageNumber}
                  active={pageNumber === currentPage}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
              <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        )}
      </MainContainer>

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header className="pt-5" closeButton>
          <Offcanvas.Title>Create New Payment Method</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form
            className="d-flex flex-column justify-content-between h-100"
            onSubmit={addNewPaymentMethod}
          >
            <div>
              <MainInput
                label={"Name*"}
                placeholder={"Enter Name....."}
                onChange={(e) => {
                  setPaymentMethodEn(e.target.value);
                }}
                value={paymentMethodEn}
                required={true}
                type={"text"}
              />
              <MainInput
                label={"*اسم"}
                placeholder={"....ادخل الاسم"}
                value={paymentMethodAr}
                required={true}
                onChange={(e) => {
                  setPaymentMethodAr(e.target.value);
                }}
                type={"text"}
                dir="rtl"
              />
              <UploadImage onChange={handleImageChange} />
            </div>

            <div className="d-flex justify-content-center align-items-center pb-3">
              <button
                type="submit"
                disabled={loadingAddPaymentMethod}
                className="btn bg-white text-main shadow-lg w-75 py-2 fw-bold"
              >
                {loadingAddPaymentMethod ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        show={showEditPaymentMethod}
        onHide={handleCloseEditPaymentMethod}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit Payment Method</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form
            className="d-flex flex-column justify-content-between h-100"
            onSubmit={editPaymentMethod}
          >
            <div>
              <MainInput
                label={"Name*"}
                placeholder={"Enter Name....."}
                onChange={(e) => {
                  setNameEnEdit(e.target.value);
                }}
                value={nameEnEdit}
                required={true}
                type={"text"}
              />
              <MainInput
                label={"*اسم"}
                placeholder={"....ادخل الاسم"}
                value={nameArEdit}
                required={true}
                onChange={(e) => {
                  setNameArEdit(e.target.value);
                }}
                type={"text"}
                dir="rtl"
              />
              <UploadImage onChange={handleImageChange} edit={imageForEdit}/>

            </div>

            <div className="d-flex justify-content-center align-items-center pb-3">
              <button
                type="submit"
                disabled={loadingEditPaymentMethod}
                className="btn bg-white text-main shadow-lg w-75 py-2 fw-bold"
              >
                {loadingEditPaymentMethod ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default PaymentMethod;
